import React from 'react';
import { Check, ArrowRight, Star, Users, ShieldCheck, Package, Gift } from 'lucide-react';
export function HeroSection() {
  return <section className="relative overflow-hidden bg-crema pt-12 pb-20 paper-texture" data-id="element-66">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-67">
        <div className="text-center max-w-4xl mx-auto mb-10" data-id="element-68">
          <div className="inline-block bg-mostaza text-marron font-bold text-xs sm:text-sm px-4 py-1.5 rounded-full uppercase tracking-wider mb-6 shadow-sm" data-id="element-69">
            ⭐ BESTSELLER — +50.000 COPIAS VENDIDAS
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-marron mb-6 leading-tight" data-id="element-70">
            Más de 100 Recetas Ancestrales con Ingredientes de tu Alacena para{' '}
            <span className="text-terracota" data-id="element-71">
              Recuperar tu Energía, Dormir Profundo y Decirle Adiós al Dolor
            </span>{' '}
            — Sin Pastillas, Sin Suplementos
          </h1>

          <p className="text-lg sm:text-xl text-marron-light italic max-w-2xl mx-auto leading-relaxed" data-id="element-72">
            Descubrí el sistema de combinaciones herbales que los herboristas
            tradicionales usaron por siglos — y que la ciencia moderna ya ha
            confirmado.
          </p>
        </div>

        {/* Social Proof Bar */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-10 text-sm font-bold text-marron max-w-3xl mx-auto" data-id="element-73">
          <div className="flex items-center justify-center bg-white/50 px-3 py-2 rounded-lg border border-marron/10 gap-2" data-id="element-74">
            <Users className="w-4 h-4 text-oliva flex-shrink-0" data-id="element-75" />
            <span className="text-xs sm:text-sm" data-id="element-76">+50.000 lectores</span>
          </div>
          <div className="flex items-center justify-center bg-white/50 px-3 py-2 rounded-lg border border-marron/10 gap-2" data-id="element-77">
            <ShieldCheck className="w-4 h-4 text-oliva flex-shrink-0" data-id="element-78" />
            <span className="text-xs sm:text-sm" data-id="element-79">Garantía 7 días</span>
          </div>
          <div className="flex items-center justify-center bg-white/50 px-3 py-2 rounded-lg border border-marron/10 gap-2" data-id="element-80">
            <Package className="w-4 h-4 text-oliva flex-shrink-0" data-id="element-81" />
            <span className="text-xs sm:text-sm" data-id="element-82">Acceso inmediato</span>
          </div>
          <div className="flex items-center justify-center bg-white/50 px-3 py-2 rounded-lg border border-marron/10 gap-2" data-id="element-83">
            <Gift className="w-4 h-4 text-oliva flex-shrink-0" data-id="element-84" />
            <span className="text-xs sm:text-sm" data-id="element-85">2 Guías gratis</span>
          </div>
        </div>

        {/* Bullets Box */}
        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-xl border-2 border-oliva/20 p-6 sm:p-8 mb-10" data-id="element-86">
          <ul className="space-y-4" data-id="element-87">
            {[<>
                Más de 100 recetas organizadas por síntoma,{' '}
                <strong className="text-oliva-dark" data-id="element-88">
                  ideal para personas +50
                </strong>{' '}
                — encontrás lo que necesitás en segundos
              </>, 'Ingredientes que ya tenés: ajo, jengibre, limón, cúrcuma, canela, aceite de oliva y más', <>
                El secreto de la{' '}
                <strong className="text-terracota" data-id="element-89">SINERGIA HERBAL</strong> —
                por qué la combinación correcta multiplica el efecto hasta 20
                veces
              </>, 'Sin equipos especiales, sin farmacias, sin receta médica', 'Con respaldo científico real — no curanderismo, no modas pasajeras', '2 Guías GRATIS incluidas + Garantía de 7 días sin preguntas'].map((item, i) => <li key={i} className="flex items-start text-marron text-base sm:text-lg" data-id="element-90">
                <Check className="w-6 h-6 text-oliva mr-3 flex-shrink-0 mt-0.5" data-id="element-91" />
                <span data-id="element-92">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-93">
          {/* Product mockup — same as pricing section */}
          <div className="relative w-full max-w-lg mx-auto mb-8 select-none" data-id="element-94">
            <img src="https://cdn.magicpatterns.com/uploads/rHE2eGbckRrpvuA5ywqQRi/recetas_ancestrales_PDF_1_-Photoroom.png" alt="Manual de Sanación Natural + Bonos (PDF)" className="w-full h-auto object-contain drop-shadow-2xl" data-id="element-95" />
          </div>

          <a href="#oferta" className="inline-flex flex-col items-center justify-center px-8 py-4 bg-oliva hover:bg-oliva-dark text-white rounded-xl shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-200 w-full sm:w-auto max-w-lg mx-auto group" data-id="element-96">
            <span className="text-xl sm:text-2xl font-bold flex items-center" data-id="element-97">
              🌿 SÍ — QUIERO MI MANUAL DIGITAL
              <ArrowRight className="ml-2 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-98" />
            </span>
            <span className="text-sm font-medium opacity-90 mt-1" data-id="element-99">
              Acceder ahora con 75% de descuento →
            </span>
          </a>

          {/* Payment logos */}
          <div className="flex flex-wrap items-center justify-center gap-3 mt-4" data-id="element-100">
            {/* Mercado Pago */}
            <div className="flex items-center gap-1.5 bg-[#009EE3] px-3 py-1.5 rounded-lg" data-id="element-101">
              <img src="https://cdn.magicpatterns.com/uploads/mb86qyhGxtkVh8xoonjKP8/channels4_profile.jpg" alt="Mercado Pago" className="w-5 h-5 rounded-full object-cover" data-id="element-102" />
              <span className="text-white text-xs font-bold tracking-wide" data-id="element-103">
                Mercado Pago
              </span>
            </div>
            {/* Visa */}
            <div className="flex items-center bg-white border border-marron/10 px-3 py-1.5 rounded-lg shadow-sm" data-id="element-104">
              <span className="font-black text-[#1A1F71] text-sm italic tracking-tight" data-id="element-105">
                VISA
              </span>
            </div>
            {/* Mastercard */}
            <div className="flex items-center gap-1 bg-white border border-marron/10 px-3 py-1.5 rounded-lg shadow-sm" data-id="element-106">
              <div className="w-5 h-5 rounded-full bg-[#EB001B] opacity-90" data-id="element-107"></div>
              <div className="w-5 h-5 rounded-full bg-[#F79E1B] -ml-2.5 opacity-90" data-id="element-108"></div>
              <span className="text-[#333] text-xs font-bold ml-1.5" data-id="element-109">
                Mastercard
              </span>
            </div>
            {/* Amex */}
            <div className="flex items-center bg-[#007BC1] px-3 py-1.5 rounded-lg" data-id="element-110">
              <span className="text-white text-xs font-bold tracking-wide" data-id="element-111">
                AMEX
              </span>
            </div>
          </div>

          <p className="mt-4 text-sm text-marron-light font-medium" data-id="element-112">
            🔒 Pago 100% seguro · Garantía de 7 días · Acceso inmediato
          </p>
        </div>
      </div>
    </section>;
}